import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">

                                            <div className="border_subtitle">Diversity issues</div>
                                            <p>Employees offer more DE if those around them are empathic. This
                                                means you need to develop the following skills: </p>
                                            <ul className="greenbullet-list bullethead_list thought-list-wordbreaknor">
                                                <li>Make it clear you're listening when an employee is talking
                                                    to you.
                                                </li>
                                                <li>Show you can see things from the employee's perspective.
                                                </li>
                                                <li>Show you care during difficult times.</li>
                                                <li>Take care that employees don't think you're encouraging
                                                    excessive workloads or longer
                                                    hours. Make sure you 'showcase' examples which haven't
                                                    involved staying at work longer,
                                                    but if this is the case, then ensure people know the
                                                    individual has been given leave in lieu.
                                                </li>
                                                <li>Give different kinds of reward, which make it clear you've
                                                    thought about the tastes and
                                                    preferences of the individuals concerned.
                                                </li>
                                            </ul>
                                            <br/>
                                            <div className="border_subtitle">Organisational environment
                                            </div>
                                            <ul className="greenbullet-list thought-list-wordbreaknor">
                                                <li>
                                                    Employees demonstrate more DE when they feel proud of
                                                    the organisation for which they
                                                    work. Activities that publicise organisational (global
                                                    or local) and team successes are key to
                                                    increasing DE - because this increases morale, which in
                                                    turn contributes to DE.
                                                </li>
                                                <li>Rewarding DE behaviour is important, but this needs to
                                                    be done carefully. Rewards should
                                                    not be predictable, or always financial.
                                                </li>
                                                <li>Give developmental support. Many employees report that
                                                    their discretionary efforts are to
                                                    develop their own skills, so building on this will
                                                    increase motivation.
                                                </li>
                                            </ul>
                                            <p>Critically, employees must never be given the impression that
                                                DE is expected of them. DE should
                                                remain exactly what it is - discretionary - and the key
                                                message should remain that DE is about recognition, not
                                                expectation. This is particularly important because
                                                employees will assume it involves working additional hours.
                                                It is essential to get the balance right - be seen to be as
                                                much
                                                of an advocate of 'work-life balance' as of DE. </p>
                                            <p>Discretionary effort can be elusive, but those most likely to
                                                demonstrate it are those who are
                                                'engaged,' which is what we're going to explain next... </p>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>UNDERSTANDING ENGAGEMENT
                                            </div>
                                            <div className="border_subtitle">What is engagement?<sup><a
                                                href="further_info.php?course=300" className="black1">5</a></sup>
                                            </div>


                                            <p>Engagement is a measure of an employee's emotional and
                                                intellectual commitment to their
                                                organisation and its success. It describes how employees
                                                behave as a result of their interactions
                                                with the organisation; that is, their involvement,
                                                contribution and ownership. </p>
                                            <p className="addspace">It's a positive attitude employees have
                                                towards the organisation and its values. An 'engaged'
                                                employee is aware of business context, and consciously works
                                                to improve the organisation's performance. Importantly, it's
                                                a two-way process; organisations must work to engage the
                                                employee, who must be allowed choice about his or her level
                                                of engagement. </p>
                                            <div className="border_subtitle">How is engagement going to help
                                                me?
                                            </div>
                                            <p>Research suggests that engaged employees show the
                                                following: </p>
                                            <ul className="greenbullet-list">
                                                <li>A belief in the organisation</li>
                                                <li>A desire to work to make things better</li>
                                                <li>An understanding of the business context and the 'bigger
                                                    picture'
                                                </li>
                                                <li>Respect and support for colleagues</li>
                                                <li>A willingness to keep up to date with developments in
                                                    the field
                                                </li>
                                                <li>Higher levels of job satisfaction</li>
                                                <li>Higher levels of organisational commitment</li>
                                                <li>More likely to engage in organisational citizenship
                                                    behaviours.
                                                </li>
                                            </ul>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}